<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div class="vx-card p-4">
      <h4 class="mb-4">Personel İşlem Raporu</h4>

      <!-- Collapsible Standard Filter Card -->
      <vs-row id="globalFilter" vs-type="flex" vs-w="12" class="bg-white p-4 mb-4 border border-solid d-theme-border-grey-light rounded" v-if="isFilterActive">
        <vs-row id="globalFilterHeader" vs-type="flex" vs-w="12" class="mb-3">
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
            <span class="text-dark weight-600 text-small">Filtreler</span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
            <feather-icon icon="XIcon" @click.stop="isFilterActive = false" class="cursor-pointer text-danger" />
          </vs-col>
        </vs-row>
        <vs-row id="globalFilterContent" vs-type="flex" vs-w="12" class="flex-wrap items-end">
          <vs-col :vs-w="showBranchFilter ? 2 : 2.4" vs-sm="6" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">Baş. Tarih</span>
            <flat-pickr v-model="dateFrom" class="w-full vs-inputx vs-input--input normal" :config="flatPickrConfig" />
          </vs-col>
          <vs-col :vs-w="showBranchFilter ? 2 : 2.4" vs-sm="6" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">Bit. Tarih</span>
            <flat-pickr v-model="dateTo" class="w-full vs-inputx vs-input--input normal" :config="flatPickrConfig" />
          </vs-col>
          <vs-col v-if="showBranchFilter" vs-w="2" vs-sm="12" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">Şube</span>
            <v-select
              v-model="selectedBranchId"
              :options="branches"
              label="name"
              :reduce="(b) => b.id"
              placeholder="Şube seçin"
              class="w-full"
              :clearable="true"
              @input="onBranchChange"
            />
          </vs-col>
          <vs-col :vs-w="showBranchFilter ? 2 : 2.4" vs-sm="12" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">Personel</span>
            <v-select
              v-model="selectedUserId"
              :options="personnels"
              label="name"
              :reduce="(p) => p.id"
              placeholder="Tümü"
              class="w-full"
              :clearable="true"
              @input="onUserIdChange"
            />
          </vs-col>
          <vs-col :vs-w="showBranchFilter ? 2 : 2.4" vs-sm="12" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">İşlem Türü</span>
            <v-select
              v-model="selectedEventType"
              :options="eventTypeOptions"
              label="label"
              :reduce="(o) => o.value"
              placeholder="Tümü"
              class="w-full"
              @input="onEventTypeChange"
            />
          </vs-col>
          <vs-col :vs-w="showBranchFilter ? 2 : 2.4" vs-sm="12" class="px-1 py-1">
            <span class="text-secondary2 text-xsmall ml-1 weight-600">Sepet ID</span>
            <input v-model="filterClientSessionId" class="w-full vs-inputx vs-input--input normal" placeholder="Sepet ID Ara..." />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" class="ml-auto" vs-w="4">
            <vs-button @click="isFilterActive = false" icon-pack="feather" icon="icon-rewind" size="small" color="warning" class="mr-2 px-6">
              Geri
            </vs-button>
            <vs-button @click="reloadAllAndClose" icon-pack="feather" icon="icon-search" color="primary" size="small" class="px-6">
              Ara
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-row>

      <!-- Standard Header / Buttons Bar -->
      <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between" class="mb-3 px-2">
        <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-align="center">
          <vs-row vs-type="flex" vs-w="12" vs-align="center">
            <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Detaylı Filtreleme" position="top">
                <vs-button
                  @click="isFilterActive = !isFilterActive"
                  class="panel-action text-warning xlarge-button panel-action-box-shadow mr-2"
                  color="transparent"
                  icon-pack="pickicon"
                  icon="icon-pick-filter"
                />
              </vx-tooltip>
            </vs-col>
            <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Excel Export" position="top">
                <vs-button
                  @click="downloadExcel"
                  class="panel-action text-dark xlarge-button panel-action-box-shadow"
                  color="transparent"
                  icon-pack="feather"
                  icon="icon-download"
                />
              </vx-tooltip>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end" vs-align="center">
          <span class="text-sm font-medium mr-2">Toplam {{ totalCount }} kayıt</span>
        </vs-col>
      </vs-row>

      <div class="self-service-log-table-wrap">
        <vs-table :data="items" :max-items="pageSize" class="self-service-log-table">
          <template slot="thead">
            <vs-th class="th-date">Tarih</vs-th>
            <vs-th class="th-branch">Şube</vs-th>
            <vs-th class="th-name">Personel</vs-th>
            <vs-th class="th-session-id">Sepet ID</vs-th>
            <vs-th class="th-event">İşlem Türü</vs-th>
            <vs-th class="th-detail">Detay</vs-th>
            <vs-th class="th-reason">Açıklama</vs-th>
            <vs-th class="th-qty">Adet</vs-th>
            <vs-th class="th-unit">B.Fiyat</vs-th>
            <vs-th class="th-total">Toplam</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="row.id" v-for="row in data" class="log-row">
              <vs-td class="td-date">
                <div class="date-part">{{ formatDatePart(row.created) }}</div>
                <div class="time-part">{{ formatTimePart(row.created) }}</div>
              </vs-td>
              <vs-td class="td-branch">{{ row.branchName || ('#' + row.branchId) }}</vs-td>
              <vs-td class="td-name">{{ row.userFullName || ('#' + row.userId) }}</vs-td>
              <vs-td class="td-session-id" :title="row.clientSessionId">
                {{ row.clientSessionId ? row.clientSessionId.split('-').pop() : '—' }}
              </vs-td>
              <vs-td class="td-event td-event-badge">
                <span :class="eventBadgeClass(row)" class="log-event-badge">{{ displayEventLabel(row) }}</span>
              </vs-td>
              <vs-td class="td-detail">
                <div class="detail-plain-text">{{ formatDetailBody(row) }}</div>
              </vs-td>
              <vs-td class="td-reason">
                <div class="detail-plain-text">{{ formatDescriptionBody(row) }}</div>
              </vs-td>
              <vs-td class="td-qty">{{ formatQuantityCell(row) }}</vs-td>
              <vs-td class="td-unit">{{ formatUnitCell(row) }}</vs-td>
              <vs-td class="td-total">{{ formatTotalCell(row) }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-pagination class="mt-2" :total="maxPage" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  getSelfServiceSessionEvents,
  getSelfServiceSessionEventsExcel
} from "@/api/SelfServiceSessionLog";
import { getBranchNameList, getPersonalNameList } from "@/api/User";

export default {
  components: { flatPickr, vSelect },
  data() {
    return {
      branches: [],
      selectedBranchId: null,
      selectedUserId: null,
      personnels: [],
      dateFrom: null,
      dateTo: null,
      flatPickrConfig: {
        dateFormat: "Y-m-d",
        allowInput: true
      },
      selectedEventType: null,
      filterClientSessionId: "",
      eventTypeOptions: [
        { label: "Tümü", value: null },
        { label: "QR Ödeme Başlatıldı", value: 10 },
        { label: "Ürün Silindi", value: 2 },
        { label: "İndirim Uygulandı", value: 11 },
        { label: "Mobil Sipariş İptal", value: 7 },
        { label: "Entegrasyon Sipariş İptal", value: 8 }
      ],
      isFilterActive: false,
      items: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 20
    };
  },
  computed: {
    maxPage() {
      if (this.totalCount <= 0) return 1;
      return Math.ceil(this.totalCount / this.pageSize);
    },
    showBranchFilter() {
      if (!Array.isArray(this.branches) || this.branches.length === 0) return false;
      if (this.branches.length > 1) return true;
      return this.$isCenterBranch() || this.$isRegionalCenterBranch();
    }
  },
  watch: {
    currentPage() {
      this.loadEvents();
    }
  },
  async mounted() {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);
    this.dateFrom = this.toYmd(start);
    this.dateTo = this.toYmd(end);
    await this.loadBranchList();
    await this.loadPersonalList();
    this.reloadAll();
  },
  methods: {
    async loadBranchList() {
      try {
        const res = await getBranchNameList();
        this.branches = res && res.status === 200 && Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.branches = [];
      }
    },
    async loadPersonalList() {
      try {
        const res = await getPersonalNameList(this.selectedBranchId);
        this.personnels = res && res.status === 200 && Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        this.personnels = [];
      }
    },
    toYmd(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    rangeParams() {
      const from = this.dateFrom ? new Date(this.dateFrom + "T00:00:00") : null;
      const to = this.dateTo ? new Date(this.dateTo + "T23:59:59") : null;
      return {
        from: from ? from.toISOString() : null,
        to: to ? to.toISOString() : null
      };
    },
    async loadEvents() {
      try {
        const { from, to } = this.rangeParams();
        const params = {
          from,
          to,
          page: this.currentPage,
          pageSize: this.pageSize
        };
        if (this.selectedEventType !== null && this.selectedEventType !== undefined) {
          params.eventType = this.selectedEventType;
        }
        if (this.selectedBranchId !== null && this.selectedBranchId !== undefined) {
          params.branchId = this.selectedBranchId;
        }
        if (this.selectedUserId !== null && this.selectedUserId !== undefined) {
          params.userId = this.selectedUserId;
        }
        if (this.filterClientSessionId) {
          params.clientSessionId = this.filterClientSessionId.trim();
        }
        const res = await getSelfServiceSessionEvents(params);
        this.items = (res.data && res.data.items) || [];
        this.totalCount = (res.data && res.data.totalCount) || 0;
      } catch (e) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Ham loglar yüklenemedi."
        });
      }
    },
    reloadAll() {
      this.currentPage = 1;
      this.loadEvents();
    },
    reloadAllAndClose() {
      this.isFilterActive = false;
      this.reloadAll();
    },
    onEventTypeChange() {
      this.currentPage = 1;
      this.loadEvents();
    },
    onUserIdChange() {
      this.currentPage = 1;
      this.loadEvents();
    },
    onBranchChange() {
      this.selectedUserId = null;
      this.loadPersonalList();
      this.currentPage = 1;
      this.loadEvents();
    },
    formatDate(v) {
      if (!v) return "";
      const d = new Date(v);
      return d.toLocaleString("tr-TR");
    },
    formatDatePart(v) {
      if (!v) return "";
      return new Date(v).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    formatTimePart(v) {
      if (!v) return "";
      return new Date(v).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
    },
    displayEventLabel(row) {
      if (!row) return "";
      if (row.eventType === "CartLineAdded") return "Ürün Eklendi";
      return row.eventTypeDisplay || row.eventType || "";
    },
    eventBadgeClass(row) {
      const t = (row && row.eventType) || "";
      if (t === "QrPaymentStarted") return "log-event-badge--info";
      if (t === "DiscountApplied") return "log-event-badge--success";
      if (
        t === "CartLineRemoved" ||
        t === "CartRemoved" ||
        t === "MobileOrderCancelled" ||
        t === "IntegrationOrderCancelled" ||
        t === "PaymentFlowCancelled"
      ) {
        return "log-event-badge--danger";
      }
      return "log-event-badge--neutral";
    },
    formatTryAmount(v) {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (Number.isNaN(n)) return "—";
      return `${n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
    },
    formatUnitCell(row) {
      if (row.unitPrice != null && row.unitPrice !== "") return this.formatTryAmount(row.unitPrice);
      if (row.eventType === "DiscountApplied" && row.payloadJson) {
        try {
          const p = JSON.parse(row.payloadJson);
          if (p.unitPrice != null) return this.formatTryAmount(p.unitPrice);
        } catch(e){}
      }
      return "—";
    },
    formatTotalCell(row) {
      if (row.lineTotal != null && row.lineTotal !== "") return this.formatTryAmount(row.lineTotal);
      if (row.eventType === "DiscountApplied" && row.payloadJson) {
        try {
          const p = JSON.parse(row.payloadJson);
          if (p.totalPrice != null) return this.formatTryAmount(p.totalPrice);
        } catch(e){}
      }
      return "—";
    },
    formatQuantityCell(row) {
      let v = row.quantity;
      if ((v === null || v === undefined || v === "") && row.eventType === "DiscountApplied" && row.payloadJson) {
        try {
          const p = JSON.parse(row.payloadJson);
          if (p.totalQuantity != null) v = p.totalQuantity;
        } catch(e){}
      }
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (Number.isNaN(n)) return "—";
      if (Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
      return n.toLocaleString("tr-TR", { maximumFractionDigits: 4 });
    },
    formatDetailBody(row) {
      if (row.eventType === "DiscountApplied" && row.payloadJson) {
        try {
          const p = JSON.parse(row.payloadJson);
          if (p.discountedItems && p.discountedItems.length > 0) {
            return p.discountedItems.map(item => `${item.productName} - x${item.quantity}`).join('\n');
          }
        } catch(e) {}
      }

      const productEventTypes = ["CartLineRemoved", "CartLineAdded", "CartLineUpdated"];
      if (!productEventTypes.includes(row.eventType)) {
        return "—";
      }

      if (row.payloadLines && row.payloadLines.length) {
        const isAciklamaLine = (line) =>
          typeof line === "string" && /^\s*(Açıklama|Ac[iı]klama)\s*:/i.test(line);
        const filtered = row.payloadLines.filter((l) => !isAciklamaLine(l));
        if (filtered.length) return filtered.join("\n");
      }
      if (row.payloadJson) return row.payloadJson;
      return "—";
    },
    formatDescriptionBody(row) {
      const parts = [];

      const productEventTypes = ["CartLineRemoved", "CartLineAdded", "CartLineUpdated"];
      if (!productEventTypes.includes(row.eventType)) {
        if (row.payloadLines && row.payloadLines.length) {
          parts.push(...row.payloadLines);
        } else if (row.payloadJson) {
          parts.push(row.payloadJson);
        }
      } else {
        if (row.payloadLines && row.payloadLines.length) {
          const isAciklamaLine = (line) =>
            typeof line === "string" && /^\s*(Açıklama|Ac[iı]klama)\s*:/i.test(line);
          const aciklamaLines = row.payloadLines.filter((l) => isAciklamaLine(l));
          if (aciklamaLines.length) {
            aciklamaLines.forEach(line => {
              const clean = line.replace(/^\s*(Açıklama|Ac[iı]klama)\s*:\s*/i, "");
              if (clean.trim()) parts.push(clean.trim());
            });
          }
        }
      }

      if (row.removeReason && row.removeReason !== "—") {
        const rr = String(row.removeReason).trim();
        if (rr && !parts.some(p => p.toLowerCase().includes(rr.toLowerCase()))) {
          parts.push(rr);
        }
      }

      return parts.length ? parts.join("\n") : "—";
    },
    downloadExcel() {
      const { from, to } = this.rangeParams();
      const params = { from, to };
      if (this.selectedEventType !== null && this.selectedEventType !== undefined) {
        params.eventType = this.selectedEventType;
      }
      if (this.selectedBranchId !== null && this.selectedBranchId !== undefined) {
        params.branchId = this.selectedBranchId;
      }
      if (this.selectedUserId !== null && this.selectedUserId !== undefined) {
        params.userId = this.selectedUserId;
      }
      if (this.filterClientSessionId) {
        params.clientSessionId = this.filterClientSessionId.trim();
      }
      getSelfServiceSessionEventsExcel(params)
        .then((res) => {
          if (res && res.status === 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "self-servis-islem-loglari.xlsx");
            document.body.appendChild(link);
            link.click();
            this.$vs.notify({ color: "success", title: "Başarılı", text: "Excel indirildi." });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata", text: "Excel alınamadı." });
        });
    }
  }
};
</script>

<style>
#data-list-thumb-view .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#data-list-thumb-view .btn-excel-export {
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.35);
}

.self-service-log-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.self-service-log-table .vs-table--tbody-table {
  table-layout: fixed;
  width: 100%;
}

.self-service-log-table .vs-table--tbody-table .vs-table--thead th {
  font-size: 0.7rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.45);
  padding-top: 10px;
  padding-bottom: 10px;
  vertical-align: bottom;
}

.self-service-log-table .vs-table--tbody-table .tr-values td,
.self-service-log-table .vs-table--tbody-table .tr-values .vs-table--td {
  vertical-align: top;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.self-service-log-table th.th-date,
.self-service-log-table td.td-date,
.self-service-log-table .vs-table--td.td-date {
  width: 6.5rem;
  max-width: 7rem;
}

.self-service-log-table th.th-name,
.self-service-log-table td.td-name,
.self-service-log-table .vs-table--td.td-name {
  width: 8.5rem;
  max-width: 9.5rem;
  word-break: break-word;
}

.self-service-log-table th.th-session-id,
.self-service-log-table td.td-session-id,
.self-service-log-table .vs-table--td.td-session-id {
  width: 6.5rem;
  max-width: 7.5rem;
  font-family: monospace;
  font-size: 0.8rem;
  text-align: center;
  color: #7d6c6a;
}

.self-service-log-table th.th-event,
.self-service-log-table td.td-event,
.self-service-log-table .vs-table--td.td-event {
  width: 9.5rem;
  max-width: 11rem;
  text-align: center;
  vertical-align: middle;
}

.self-service-log-table th.th-detail,
.self-service-log-table td.td-detail,
.self-service-log-table .vs-table--td.td-detail {
  width: 28rem;
  vertical-align: top;
}

.self-service-log-table th.th-reason,
.self-service-log-table td.td-reason,
.self-service-log-table .vs-table--td.td-reason {
  width: 14rem;
  font-size: 0.8125rem;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.self-service-log-table th.th-qty,
.self-service-log-table td.td-qty,
.self-service-log-table .vs-table--td.td-qty {
  width: 3.25rem;
  max-width: 4rem;
  text-align: center;
}

.self-service-log-table th.th-unit,
.self-service-log-table td.td-unit,
.self-service-log-table .vs-table--td.td-unit {
  width: 4rem;
  max-width: 4.75rem;
  text-align: right;
  white-space: nowrap;
  font-size: 0.75rem;
}

.self-service-log-table th.th-total,
.self-service-log-table td.td-total,
.self-service-log-table .vs-table--td.td-total {
  width: 5.5rem;
  max-width: 6.5rem;
  text-align: right;
  white-space: nowrap;
}

#data-list-thumb-view .date-part {
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.2;
  white-space: nowrap;
}

#data-list-thumb-view .time-part {
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 2px;
  white-space: nowrap;
}

#data-list-thumb-view .td-name {
  font-size: 0.8125rem;
}

#data-list-thumb-view .td-event-badge {
  text-align: center;
}

#data-list-thumb-view .log-event-badge {
  display: inline-block;
  max-width: 100%;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.25;
  color: #fff;
  text-align: center;
  overflow-wrap: anywhere;
}

#data-list-thumb-view .log-event-badge--success {
  background: #28a745;
}

#data-list-thumb-view .log-event-badge--danger {
  background: #dc3545;
}

#data-list-thumb-view .log-event-badge--warn {
  background: #ffc107;
  color: #333;
}

#data-list-thumb-view .log-event-badge--info {
  background: #17a2b8;
}

#data-list-thumb-view .log-event-badge--neutral {
  background: #6c757d;
}

#data-list-thumb-view .detail-plain-text {
  white-space: pre-line;
  font-size: 0.8125rem;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.88);
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: top;
}

.self-service-log-table .tr-values.log-row:hover td,
.self-service-log-table .tr-values.log-row:hover .vs-table--td {
  background-color: rgba(184, 149, 108, 0.06);
}

/* Tarih girdileri ile vue-select dropdown kutularının yüksekliklerini ve hizalamalarını eşitle */
#data-list-thumb-view .vs-input--input,
#data-list-thumb-view .vs__dropdown-toggle {
  height: 38px !important;
  box-sizing: border-box !important;
}

#data-list-thumb-view .vs__dropdown-toggle {
  display: flex !important;
  align-items: center !important;
}

#data-list-thumb-view .vs__selected-options {
  flex-wrap: nowrap !important;
}

#data-list-thumb-view .vs__actions {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
